<main class="flex-grow">
  <router-outlet />
</main>

<app-frontend-footer></app-frontend-footer>
